import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

interface LandingPageProps {
  onAuthenticate: () => void;
}

const LandingPage: React.FC<LandingPageProps> = ({ onAuthenticate }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const handleSubmit = (e: React.FormEvent, passwordValue?: string) => {
    e.preventDefault();
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    const passwordToSubmit = passwordValue || password;
    if (passwordToSubmit === 'cashew') {
      onAuthenticate();
      navigate('/event-details'); // Redirect to the first main page after login
    } else {
      setError('Incorrect password. Please try again.');
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    const newPassword = e.target.value;
    setPassword(newPassword);

    if (newPassword.length === 6) {
      timerRef.current = setTimeout(() => {
        // Create a synthetic event for handleSubmit
        const syntheticEvent = { preventDefault: () => {} } as React.FormEvent;
        handleSubmit(syntheticEvent, newPassword);
      }, 1000);
    }
  };

  return (
    <div className="landing-page-container d-flex justify-content-center align-items-center vh-100">
        <img src="/images/double_palm.png" alt="Palm Tree" className="landing-palm-image" />
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <input
              type="password"
              className="form-control"
              id="passwordInput"
              value={password}
              onChange={handleChange}
              required
              placeholder="password..."
            />
          </div>
          {error && <div className="alert alert-danger" role="alert">{error}</div>}
        </form>
    </div>
  );
};

export default LandingPage;
